import I18n from "lib/i18n/i18n";
import {rootUrl} from "../../helpers/ApplicationHelper";
import ExpandableLI from "../expandableLI";
import React from "react";

const ListingFAQ = ({ item, parent, needsTitle, userActionsCb, experiments, P13N }) => {
    // console.log("item, Listing, onFAQClick, goTo", item, Listing, onFAQClick, goTo);

    return <div className='faq-section'>
        {
            needsTitle ? <h2 className='listing-title h2'> { I18n.getString('listingPage::faqSection::title') }</h2> : null
        }
        <ul className='faq-list-items'>
            {
                I18n.getVar('listingPage::faqSection::faqs').map((listItem, i) => {
                    if (listItem.expandText.includes('{fees_table}')) {
                        const fees_table = I18n.getString('feesTable');
                        listItem.expandText = listItem.expandText.replace('{fees_table}', fees_table)
                    }
                    let text = listItem.expandText;

                    if (listItem.expandTextTest && parent.number === '3') {
                        text = listItem.expandTextTest.replace('{item_type}', item.item_type)
                    }

                    if (text.includes('{item_type}')) {
                        text = text
                            .replace('{item_type}', item.item_type)
                            .replace('{env_name}', rootUrl());
                    }

                    return <ExpandableLI
                        onClick={ () => {
                            // FIXME: wasOpened = false looks always false or true
                            const wasOpened = false;
                            userActionsCb(`FAQ «${listItem.bullet}»${ wasOpened ? ' closed' : ' opened' }`, item.id, parent.getVersion({item, experiments, P13N}));

                            setTimeout(() => {
                                const trendsLink = document.querySelector('.listingTrendsLink');
                                trendsLink && trendsLink.addEventListener('click', () => {
                                    parent.goTo(`/listing/${item.id}/trends`, 'Can I get an estimate before I ship my valuable - Trends clicked', item.id, true)
                                })
                                const recentAuctionsLink = document.querySelector('#recent-auction-link');
                                recentAuctionsLink && recentAuctionsLink.addEventListener('click', () => {
                                    parent.goTo(`/about/recent-deals/rings`, 'Nurturing-flow Recent auction link clicked', item.id, false)
                                })
                            }, 100)
                        }}
                        item={ item }
                        key={ i }
                        expandText={ text }
                        bullet={ listItem.bullet }
                        goTo={ parent.goTo }
                        plusColor='blue'/>
                })
            }
            <li className="expandable-LI">
                <div className="list-item" onClick={() => parent.goTo('/about/how-it-works', 'FAQ «Learn more» button clicked', item.id)}>
                    <span className="bullet">{I18n.getString('listingPage::readMore')}</span>
                    <div className={'icon arrowblue'}/>
                </div>
            </li>
        </ul>
    </div>
};

export default ListingFAQ;
